import React, { useState } from 'react'
import classnames from 'classnames'
import styles from './index.scss'

const HistorySold = () => {
  const [historyShowCount, setHistoryShowCount] = useState(1)

  const soldcars = [[{
    id: 1,
    dghref: '/buy/detail/bef5e2fcce49fda2',
    pic: 'o_1a1pv6972421012898461124166481323.jpg',
    version: '大众-迈腾2009款 2.0TSI DSG豪华型',
    time: '2009年09月/7.00万公里',
    price: '11.3万',
    compare: '9000元',
    solddate: 3
  }, {
    id: 2,
    dghref: '/buy/detail/cdc3333c3d6c68f4',
    pic: 'o_1a1vog16h30484426184855280571546.jpg',
    version: '奥迪-A3 2014款 Limousine 35 TFSI进取型',
    time: '2015年04月/0.67万公里',
    price: '16.7万',
    compare: '2万元',
    solddate: 5
  }, {
    id: 3,
    dghref: '/buy/detail/a12ad53af6063ab9',
    pic: 'o_1a1i8bbb84270840472234471109536203.jpg',
    version: '宝马-5系 2012款 520Li 典雅型',
    time: '2012年05月/2.15万公里',
    price: '28.5万',
    compare: '1.8万元',
    solddate: 3
  }, {
    id: 4,
    dghref: '/buy/detail/6e511f8179c2148d',
    pic: 'o_1a2hdfte33218056385221862597061860.jpg',
    version: '丰田-凯美瑞 2010款 200G 经典版',
    time: '2010年12月/10.84万公里',
    price: '10.5万',
    compare: '1.1万元',
    solddate: 2
  }], [{
    id: 5,
    dghref: '/buy/detail/4fbed6af1c32e550',
    pic: 'o_1a1vq27ek1394534447353052914210751.jpg',
    version: '大众-高尔夫 2012款 2.0TSI GTI',
    time: '2012年05月/6.39万公里',
    price: '15.5万',
    compare: '1.1万元',
    solddate: 2
  }, {
    id: 6,
    dghref: '/buy/detail/98866f0540323a2f',
    pic: 'o_1a29iima1564575056658049138560157.jpg',
    version: '长城汽车-哈弗H6 2011款 2.0L 手动两驱都市型',
    time: '2012年03月/3.92万公里',
    price: '7.35万',
    compare: '8000元',
    solddate: 3
  }, {
    id: 7,
    dghref: '/buy/detail/44c923b88b829c4d',
    pic: 'o_1a2jq0lbo115575700529482790132682.jpg',
    version: '别克-凯越2011款 1.6LE-MT',
    time: '2012年06月/3.90万公里',
    price: '5.38万',
    compare: '6000元',
    solddate: 5
  }, {
    id: 8,
    dghref: '/buy/detail/2351c2c3d6013cf4',
    pic: 'o_1a24gn90g536419919615094751510030.jpg',
    version: '日产-阳光2011款 1.5XE MT舒适版',
    time: '2012年12月/4.40万公里',
    price: '5.00万',
    compare: '5000元',
    solddate: 4
  }], [{
    id: 9,
    dghref: '/buy/detail/333981b608183929',
    pic: 'o_1a272vbi1476313913249350774845044.jpg',
    version: '现代-悦动2010款 1.6L AT GLS',
    time: '2010年11月/5.60万公里',
    price: '5.50万',
    compare: '6000元',
    solddate: 7
  }, {
    id: 10,
    dghref: '/buy/detail/ede9b8f232a8db5c',
    pic: 'o_1a0oejj0r14164598353146288325818.jpg',
    version: '福特-嘉年华 2009款 三厢 1.5L 自动时尚型',
    time: '2009年07月/3.53万公里',
    price: '5.00万',
    compare: '5000元',
    solddate: 5
  }, {
    id: 11,
    dghref: '/buy/detail/a6ece396c1f42ad8',
    pic: 'o_1a167jmei56065710257725263236550.jpg',
    version: '马自达-6 2011款 2.0L 自动豪华型',
    time: '2010年12月/6.99万公里',
    price: '7.90万',
    compare: '8000元',
    solddate: 2
  }, {
    id: 12,
    dghref: '/buy/detail/1b10c562ea8dd528',
    pic: 'o_1a03n3vbj6201761132368661103747516.jpg',
    version: '斯柯达-明锐2012款 1.6L 手动逸杰版',
    time: '2012年10月/2.20万公里',
    price: '7.40万',
    compare: '6000元',
    solddate: 3
  }]]
  return (
    <div className={styles['r-history']}>
      <div className="title">历史售出</div>
      <div className="title-line" />
      <div className="container clearfix">
        <i className="iconfont icon-middl_color_right-a4775df2 left" data-click="sales_history_left" onClick={() => { setHistoryShowCount(historyShowCount - 1 < 1 ? 3 : historyShowCount - 1) }} />
        <ul className="content clearfix">
          {
              soldcars.map((v, i) => (
                <li key={i} className={classnames('item', { selected: historyShowCount === (i + 1) })}>
                  {v.map(c => (
                    <div key={c.id} className="item-child">
                      <a href={c.dghref} target="_blank" rel="noopener noreferrer" data-click={`sales_history_car${c.id}`}>
                        <div className="pic">
                          <img className="sales-search-pic" src={`//img2.rrcimg.com/${c.pic}`} alt="历史售出" />
                          <div className={`sales-date day${c.solddate}`} />
                        </div>
                        <div className="intro">
                          <p className="version two-line">{ c.version}</p>
                          <p className="time single-line">{ c.time}</p>
                          <div className="pc">
                            <p className="price">{ c.price}</p>
                            <p className="compare">
                              <span className="c-price">{ c.compare}</span>
                            </p>
                          </div>
                        </div>
                      </a>
                    </div>
                  ))}
                </li>
              ))
            }
        </ul>
        <i className="iconfont icon-middl_color_right-a4775df2 right" data-click="sales_history_right" onClick={() => { setHistoryShowCount(historyShowCount + 1 > 3 ? 1 : historyShowCount + 1) }} />
      </div>
    </div>
  )
}


export default HistorySold
